import { render, staticRenderFns } from "./tagListMove.vue?vue&type=template&id=8a4f99da&scoped=true&"
import script from "./tagListMove.vue?vue&type=script&lang=js&"
export * from "./tagListMove.vue?vue&type=script&lang=js&"
import style0 from "./tagListMove.vue?vue&type=style&index=0&id=8a4f99da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4f99da",
  null
  
)

export default component.exports